import {set, keys} from "idb-keyval";

const KEYS_FOR_MIGRATE = [
    'archived_contractDatas',
    'archived_buyerDatas',
    'archived_showingDatas',
];

class Storage {
    async init() {
        const existingKeys = await keys();

        for (let key of KEYS_FOR_MIGRATE) {
            if (existingKeys.includes(key)) continue;

            const localValue = window.localStorage.getItem(key);
            if (localValue == null) continue;

            await set(key, localValue);
            window.localStorage.removeItem(key);
        }
    }
}

export default new Storage();